import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";

import * as productService from "@features/products/services/productService";
import ProductCard from "@features/products/components/ProductCard";
import { StockHistoryManager } from "@features/products/components/StockHistoryManager";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@shared/components/ui/card";
import { format } from "date-fns";
import { CalendarCheck2, History } from "lucide-react";
import { useTranslation } from "react-i18next";
import HeadLayout from "@shared/layouts/HeadLayout";

const ProductDetailsPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ["product", id],
    queryFn: async () => await productService.fetchProductByID(id),
  });

  const { data: packages, isLoading: packagesLoading } = useQuery({
    queryKey: ["product", "packagesForProduct", id],
    queryFn: async () => await productService.fetchPackagesForProduct(id),
  });

  const { data: pickups, isLoading: pickupsLoading } = useQuery({
    queryKey: ["product", "pickupsForProduct", id],
    queryFn: async () => await productService.fetchPickupsForProduct(id),
  });

  if (isLoading) {
    return <div>{t("main.loading")}</div>;
  }

  return (
    <>
      <HeadLayout title={t("packages.productDetails")} />
      <div className="max-w-screen-2xl mx-auto flex flex-col gap-4 sm:gap-6 lg:gap-10 px-4 sm:px-6 lg:px-8">
        <ProductCard product={data} className={"shadow-sm"} />

        {/* Stock History Section */}
        <Card>
          <CardHeader className="pb-3 sm:pb-6">
            <CardTitle className="flex items-center gap-2 text-base sm:text-lg">
              <History className="w-4 h-4 sm:w-5 sm:h-5" />
              {t("products.stockHistory")}
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-0">
            <StockHistoryManager productId={id} />
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default ProductDetailsPage;
